'use client'

import { FC, useEffect, useRef, useState } from 'react'

import { useAiChatUi } from '@/entities/ai-chat'
import { useCart } from '@/entities/cart'

import { formatPrice } from '@/shared/lib/utils/price/format-price'

import { BasketInfoOrderButton, CHECKOUT_BUTTON_ID } from '../basket-summary/basket-summary'

import cl from './cart-order-block-mobile.module.scss'

export const CartOrderBlockMobile: FC = () => {
	const { price } = useCart()
	const totalPrice = price ?? 0
	const [isRealButtonVisible, setIsRealButtonVisible] = useState(false)
	const { setPortalTarget } = useAiChatUi()
	const aiChatPortalRef = useRef<HTMLDivElement>(null)

	useEffect(() => {
		const element = document.getElementById(CHECKOUT_BUTTON_ID)
		if (!element) return

		const observer = new IntersectionObserver(
			([entry]) => {
				setIsRealButtonVisible(entry.isIntersecting)
			},
			{
				root: null,
				rootMargin: '0px',
				threshold: 0
			}
		)

		observer.observe(element)
		return () => observer.disconnect()
	}, [])

	useEffect(() => {
		if (!isRealButtonVisible && aiChatPortalRef.current) {
			setPortalTarget(aiChatPortalRef.current)
		} else {
			setPortalTarget(null)
		}
	}, [isRealButtonVisible, setPortalTarget])

	useEffect(() => {
		return () => setPortalTarget(null)
	}, [setPortalTarget])

	return (
		<div className={cl.block} data-hidden={isRealButtonVisible} role="region" aria-label="Оформление заказа">
			<div className={cl.total}>
				<strong>{formatPrice(totalPrice)}</strong>
			</div>
			<div className={cl.buttonWrapper}>
				<BasketInfoOrderButton className={cl.button} fullWidth />
			</div>
			<div ref={aiChatPortalRef} className={cl.aiChatWrapper} />
		</div>
	)
}
